import { PhoenixMetrics } from "@amzn/ads-phoenix-type-script-client";
import type { GeneratedInsight } from "@amzn/d16-g-client-deck-builder-typescript-client";
import { InsightType } from "@amzn/d16-g-client-deck-builder-typescript-client";
import { Button, HelpTip } from "@amzn/storm-ui";
import React from "react";
import { useNavigate } from "react-router-dom";
import { isTruthy } from "remeda";

import {
    TELEMETRY_ID,
    PHOENIX_FEATURE,
} from "../../../../../constants/telemetry";
import { logWithTakt } from "../../../../../utils/telemetry.utils";
import { getSearchParamsAndOverride } from "../../../../../utils/url.utils";

export const EditInputsButton: React.FunctionComponent<{
    insight: GeneratedInsight;
}> = ({ insight }) => {
    const navigate = useNavigate();
    const domain = insight?.domainIdentifier;
    const template = insight?.templateIdentifier;
    const identifier = insight?.identifier;

    const isEnabled = React.useMemo(() => {
        return isTruthy(domain && template && identifier);
    }, []);

    const handleEditInputs = () => {
        if (isEnabled) {
            logWithTakt(TELEMETRY_ID.IHUB_CUSTOM_INSIGHTS_CLONE, {
                domainIdentifier: domain,
                templateIdentifier: template,
                identifier,
            });
            PhoenixMetrics.emit(
                TELEMETRY_ID.IHUB_CUSTOM_INSIGHTS_CLONE,
                PHOENIX_FEATURE.DISCOVERY,
                {
                    contentInfo: template
                        ? {
                              contentProvider: InsightType.CDB_TEMPLATE,
                              contentType: "",
                              contentId: template,
                          }
                        : undefined,
                    customData: {
                        domainIdentifier: domain,
                        identifier,
                    },
                },
            );
            navigate({
                pathname: `/domains/${domain}/templates/${template}`,
                search: getSearchParamsAndOverride({
                    getPayloadFromInsight: identifier as string,
                }),
            });
        }
    };

    if (isEnabled) {
        return (
            <Button
                data-testid="cdb-deep-link-insights"
                onClick={() => {
                    handleEditInputs();
                }}
            >
                Clone
                <HelpTip>Recreate this insight with new inputs</HelpTip>
            </Button>
        );
    } else {
        return <></>;
    }
};
